import Success from "components/success/index";
import Authentication from "containers/AuthenticationPage/index";
import Password from "components/Password/index";
import VerifyOtp from "containers/OtpScreen/index";
import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

// for invited user
const ResetPasswordContainer = ({ invite }) => {
    const [step, setStep] = useState(1);
    const nextStep = () => setStep(step + 1);
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");
    const token = searchParams.get("token");
    if (!email || !token) {
        return <div>Invalid link. Please check your email.</div>;
    }

    const navigate = useNavigate();
    const signinHandler = () => {
        navigate("/signin");
    };
    return (
        <>
            {step === 1 && (
                <Password nextStep={nextStep} id={token} email={email} isReset={true} />
            )}
            {step === 2 && <Authentication nextStep={nextStep} skip={true} setStep={setStep} />}
            {step == 3 && (
                <VerifyOtp
                    invite={true}
                    setStep={setStep}
                    onlyTotp={true}
                />
            )}
            {step === 5 && (
                <Success
                    success={true}
                    title="Password Reset Successful"
                    subTitle="Please continue to Sign In!"
                    buttonText="Sign in"
                    onClick={signinHandler}
                />
            )}
        </>
    );
};

export default ResetPasswordContainer;
